module.exports = __webpack_public_path__ + "static/media/pass-lock.e5a96d11.svg";